/**
 * Custom Shopify Chat launchers:
 * - Mobile: sticky toolbar [data-inbox-chat]
 * - Desktop: header ? icon [data-inbox-chat]
 * Floating bubble stays hidden; panel opens via show().
 */
(function () {
  var busyUntil = 0;
  var watchedHosts = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var HIDE_STYLE =
    ':host(:not([open])) .activator,' +
    ':host(:not([open])) button.activator,' +
    ':host(:not([open])) .activator-nudge,' +
    '.activator,button.activator,.activator-nudge{' +
    'display:none!important;opacity:0!important;visibility:hidden!important;' +
    'pointer-events:none!important;position:fixed!important;' +
    'left:-9999px!important;top:auto!important;bottom:auto!important;' +
    'width:0!important;height:0!important;min-width:0!important;min-height:0!important;' +
    'overflow:hidden!important;clip:rect(0,0,0,0)!important;margin:0!important;padding:0!important;border:0!important;}';

  var SESSION_KEYS = [
    'shopify-chat-open',
    'shopify-chat-open-path',
    'shopify-chat-navigation-open-restore',
    'shopify-chat-nav-origin'
  ];

  function clearStaleOpenIntent() {
    try {
      for (var i = 0; i < SESSION_KEYS.length; i++) {
        sessionStorage.removeItem(SESSION_KEYS[i]);
      }
    } catch (e) {}
  }

  function findHost() {
    return document.querySelector('shopify-chat');
  }

  function hasOpenAttribute(host) {
    if (!host || !host.hasAttribute('open')) return false;
    return host.getAttribute('open') !== 'false';
  }

  function setCustomChatMode(enabled) {
    var root = document.documentElement;
    var body = document.body;
    if (enabled) {
      root.classList.add('has-inbox-toolbar-chat');
      if (body) body.classList.add('has-inbox-toolbar-chat');
    } else {
      root.classList.remove('has-inbox-toolbar-chat');
      if (body) body.classList.remove('has-inbox-toolbar-chat');
    }
  }

  function injectActivatorHide(host) {
    if (!host) return;
    var root;
    try {
      root = host.shadowRoot;
    } catch (e) {
      return;
    }
    if (!root) return;

    var style = root.querySelector('style[data-hide-inbox-launcher]');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute('data-hide-inbox-launcher', '1');
      root.appendChild(style);
    }
    if (style.textContent !== HIDE_STYLE) style.textContent = HIDE_STYLE;

    watchHost(host, root);
  }

  function watchHost(host, root) {
    if (watchedHosts) {
      if (watchedHosts.has(host)) return;
      watchedHosts.add(host);
    } else if (host.getAttribute('data-toolbar-chat-watched') === '1') {
      return;
    } else {
      host.setAttribute('data-toolbar-chat-watched', '1');
    }

    try {
      new MutationObserver(function () {
        injectActivatorHide(host);
      }).observe(host, { attributes: true, attributeFilter: ['open'] });
    } catch (e) {}

    try {
      new MutationObserver(function () {
        injectActivatorHide(host);
      }).observe(root, { childList: true, subtree: true });
    } catch (e) {}
  }

  function maintain() {
    setCustomChatMode(true);
    injectActivatorHide(findHost());
  }

  function openChat(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (Date.now() < busyUntil) return;

    var host = findHost();
    if (!host) {
      var waits = 0;
      var waitTimer = setInterval(function () {
        waits += 1;
        host = findHost();
        if (host) {
          clearInterval(waitTimer);
          busyUntil = 0;
          openChat(null);
        } else if (waits > 40) {
          clearInterval(waitTimer);
        }
      }, 100);
      return;
    }

    if (hasOpenAttribute(host)) return;

    busyUntil = Date.now() + 900;
    injectActivatorHide(host);

    try {
      if (typeof host.close === 'function') host.close();
    } catch (e) {}

    if (typeof host.show === 'function') {
      try {
        host.show();
      } catch (e) {}
    }

    setTimeout(function () {
      host = findHost();
      injectActivatorHide(host);
      if (!host || hasOpenAttribute(host)) return;
      try {
        if (typeof host.show === 'function') host.show();
      } catch (e) {}
    }, 200);
  }

  function onClick(event) {
    var t = event.target;
    if (!t || !t.closest || !t.closest('[data-inbox-chat]')) return;
    openChat(event);
  }

  function init() {
    clearStaleOpenIntent();
    document.addEventListener('click', onClick, true);
    setCustomChatMode(true);
    maintain();
    setInterval(maintain, 400);

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-chat').then(maintain).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
